// 参数类型 int float
export enum ProgressParamType {
    INT = "int",
    FLOAT = "float",
    DOUBLE = "double",
    STRING = "string",
    ENUM = "enum",
    ARRAY = "array",
    CHAR = "char",
    FILE_DIR = "filedir",
    FILE = "file",
    DATE = 'datetime',
    RESULT_DIR = 'result_dir',
    SELECT = 'select',
    SURVEYEDIT = 'surveyedit',
    DWESEDIT = 'dwesedit',
    TOMOPICKEDIT = 'tomopickedit',
}

export type FileSourceType = 'DISK' | 'CACHE' | 'DB' | 'LOCAL';

// 参数接口 包括参数名，参数默认值，参数类型，参数描述，参数序号
export interface IModuleParam {
    USEADVISEPARAM: boolean;
    SUGGESTPARAM: string;
    ACTION: string;
    PARAMMIN: any;
    PARAMMAX: any;
    PARAMALIASNAME?: string
    PARAMNAME: string,
    PARAMDEFAULTVALUE: string | number,
    PARAMTYPE: ProgressParamType
    PARAMDESC: string,
    PARAMINDEX: number,
    PARAMDEVALUERANGE?: string,
    HIDE: 'YES' | 'NO',
    PARAMLIMIT: number,
    REGX_PATTERN?: string,
    REGX_ATTRIBUTES?: string
    FILESOURCE?: FileSourceType;
    ISDIR?: boolean;
    SUFFIX?: string;
    PREFIX?: string;
    CHILDREN?: {
        [key: string]: {
            SELECT_PARAM_NAME: string,
            PRO_MODULE_PARAMS: IModuleParam[];
        }
    };
}

export interface IMoudlePick {
    entrypoint: string;
    MAPTYPE: "FREQDIS";
}

// 模块接口，包括模块名、参数、模块描述、别名
export interface IModuleInfo {
    DOWNLOAD: string,
    PRO_MODULE_ALIASNAME: string,
    PRO_MODULE_NAME: string,
    PRO_MODULE_DESC: string,
    PRO_MODULE_CATEGORY: string;
    PRO_MODULE_CLASS: string;
    PRO_MODULE_EXECORDER: number,
    PRO_MODULE_TECHTYPE?: string,
    PRO_MODULE_LANGUAGE?: string,
    PRO_MODULE_MEDIA?: string,
    QC: string,
    PRO_MODULE_PARAMS: IModuleParam[],
    PICK?: IMoudlePick;
    TECHNIC_PREFIX?: string;
}


export enum IModuleParamSet {
    HIDE = 1,
    LIMIT = 3,
}

export enum IMoudeSet {
    QC = 1,
    DOWNLOAD = 2,
}